import MostProjectCollaborator from "./MostProjectCollaborator";

export default function Stat() {
  return (
    // <section className="block stat">
    //   <div className="title">
    //     <h2>Statistiques</h2>
    //   </div>
    // </section>
    <MostProjectCollaborator className="stat">
      Statistiques
    </MostProjectCollaborator>
  );
}
